import { BorrowerDocumentationRequired, DocumentStatus, RequiredFile } from '@nemuru-eng/js-api-client';

export const updateBorrowerDocumentationRequired = async ({
  borrowerDocumentationRequired,
  filesToUpdate,
  validate,
  update,
}: {
  borrowerDocumentationRequired: BorrowerDocumentationRequired;
  filesToUpdate: RequiredFile[];
  validate: boolean;
  update: ({ borrowerDocumentationRequired }: { borrowerDocumentationRequired: BorrowerDocumentationRequired }) => void;
}) => {
  if (!borrowerDocumentationRequired.requiredFiles) return;

  const fileNamesToUpdate = new Set(filesToUpdate.map((file) => file.name));
  const newStatus = validate ? DocumentStatus.VALIDATED : DocumentStatus.INCIDENCE;

  borrowerDocumentationRequired.requiredFiles.forEach((requiredFile) => {
    if (fileNamesToUpdate.has(requiredFile.name)) {
      requiredFile.status = newStatus;
    }
  });

  update({ borrowerDocumentationRequired });
};
